import { CreateLockProcessParams, DeleteLockProcessParams } from "@/actions/types/lockProcess";
import * as constants from "@/constants";
import environments from "@/environments";

// 明細ロック設定登録
export const createLockProcess = (params: CreateLockProcessParams, callback?: () => void, fallback?: () => void) => {
  const endpoint = `${environments.API_BASE_URI}/lock_processes/create`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    body: JSON.stringify(params),
    callbacks: {
      begin: () => {
        return {
          type: constants.MATRIX_BEGIN_CREATE_LOCK_PROCESS,
        };
      },
      success: (response) => {
        callback?.();

        return {
          type: constants.MATRIX_END_CREATE_LOCK_PROCESS,
          payload: response,
        };
      },
      error: (response) => {
        fallback?.();

        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

// 明細ロック設定削除
export const deleteLockProcess = (params: DeleteLockProcessParams, callback?: () => void) => {
  const endpoint = `${environments.API_BASE_URI}/lock_processes/delete`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    callbacks: {
      begin: () => {
        return {
          type: constants.MATRIX_BEGIN_DELETE_LOCK_PROCESS,
        };
      },
      success: (response) => {
        callback?.();

        return {
          type: constants.MATRIX_END_DELETE_LOCK_PROCESS,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};
